<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="27"></FHeader>
		<FOtherBanner :name1="'资讯动态'" :name2="'Information Dynamics'"></FOtherBanner>
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">资讯动态</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
				<div class="">
					<FNewsInformation></FNewsInformation>
				</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;">
				<div>
					<span style="font-size: 26px;font-weight: 900;color: #98273A;">全部新闻</span>
				</div>
				<div :style="{'padding-top':'10px','height':((tableList.length*130)+50)+'px'}">
					<div :style="{height:'120px','border-bottom':'1px solid #D7D7D7','margin-top':'10px'}" v-for="(item,index) in tableList" :key="index">
						<div style="float: left;width:100%;padding-right: 30px;">
							<div style="width: 100%;height: 50px;">
								<div  @click="toDetail(item)" class="cultureType" style="    width: 90%;float:left;font-size: 18px;line-height: 50px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">{{item.title}}</div>
								<div style="text-align: right;float: left;width: 10%;color: #7F7F7F;font-size: 14px;line-height:50px;">{{item.publish.substring(0,10)}}</div>
							</div>
							<div @click="toDetail(item)" style="font-size: 14px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;line-height: 24px;-webkit-box-orient: vertical;color: #7F7F7F;cursor: pointer;">{{item.description}}</div>
						</div>
					</div>
				</div>
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:page-size="6"
					:total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"
	import FNewsInformation from "../../components/f/FNewsInformation.vue"

	import {query} from "@/api/article";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			FNewsInformation,
			Footer
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
				type:'律师培养'
			}
		},
		mounted() {
			this.list()
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
			changeType(type){
				this.type = type;
				this.pageNo = 1;
				this.list()
			},
			async toDetail(item,index){
				this.$router.push(
					{
						path:'/newsDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					channelId:13,
					title: '',
					page: this.pageNo,
					pageSize: 6,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">
	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
.cultureType{
	cursor: pointer;
}
.cultureType:hover{
	color: rgb(152, 39, 58);
}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
